var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('part-form',{attrs:{"pageTitle":_vm.$metaInfo.title}}),(_vm.requirementId)?_c('tabs'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }